@if (
  {
    ort: ort$ | async,
    suchwort: suchwort$ | async,
    correction: correction$ | async,
    removedToken: removedToken$ | async,
    bildungsangebote: (bildungsangebote$ | async)!,
    bildungsangeboteLoadingWithoutPageChange: angeboteLoadingWithoutPageChange$ | async
  };
  as context
) {
  <div aria-label="Liste der Suchergebnisse" id="ergebnisliste" class="gx-0 gx-xl-4 mb-3">
    @if (context.bildungsangeboteLoadingWithoutPageChange === false) {
      <div class="grid-container">
        <div class="item-top-left fade-in-anchor">
          @if (isDesktop$ | async) {
            <div class="d-flex align-with-angebot flex-column">
              <now-wbsuche-lib-suchergebnis-hits-card></now-wbsuche-lib-suchergebnis-hits-card>
            </div>
          }
          @if (
            (paginationService.hasPreviousePage$ | async) && context.bildungsangebote.length > 0
          ) {
            <button
              class="page-change-button now-btn now-btn-secondary mb-3"
              id="load_previouse_angebote"
              (click)="prevPageClicked()"
              [attr.disabled]="(angeboteLoadingByPageChange$ | async) === true ? true : null"
              [ngClass]="{ 'now-btn-loading': angeboteLoadingByPageChange$ | async }"
            >
              Vorherige Angebote anzeigen
            </button>
          }
          <now-wbsuche-lib-angebot-list
            [angebote]="context.bildungsangebote"
            [selectedAngebotId]="(selectedAngebotId$ | async) || undefined"
            (angebotSelected)="setSelectedAngebot($event)"
          ></now-wbsuche-lib-angebot-list>
        </div>
        <div class="item-right border-secondary border-start">
          <now-wbsuche-lib-angebot-termine
            class="d-block"
            [ngClass]="{ 'sticky-top z-index-1': (isLargeDesktop$ | async) }"
            [style.padding-top]="(isLargeDesktop$ | async) === true ? headerOffset + 'px' : null"
            (terminSelected)="terminSelected.emit($event)"
            #termineElement
          ></now-wbsuche-lib-angebot-termine>
        </div>
        <div class="item-bottom-left">
          @if ((paginationService.hasNextPage$ | async) && context.bildungsangebote.length > 0) {
            <button
              class="d-flex justify-content-center page-change-button now-btn now-btn-secondary mt-3 custom-centered"
              id="load_more_angebote"
              (click)="nextPageClicked()"
              [attr.disabled]="(angeboteLoadingByPageChange$ | async) === true ? true : null"
              [ngClass]="{ 'now-btn-loading': angeboteLoadingByPageChange$ | async }"
            >
              Weitere Angebote anzeigen
            </button>
          }
          @if (libConfig.showThemenfelder === true) {
            <div id="themenfelder_card" class="now-decorative-card pb-3 pt-3 mt-3">
              <div class="mb-1">
                Nicht sicher, wonach Sie suchen sollen? Nutzen Sie die <b>Themenfelder</b> um die
                passende Suche zu starten.
              </div>
              <div class="d-flex justify-content-center">
                <button
                  id="themenfelder_btn"
                  (click)="navigateToThemenfelder()"
                  type="button"
                  class="now-btn now-btn-tertiary"
                >
                  Nach Themenfeldern suchen
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <svg
        width="50"
        height="50"
        xmlns="http://www.w3.org/2000/svg"
        class="loading-spinner"
        viewBox="0 0 100 100"
      >
        <title>Angebote werden geladen</title>
        <g>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 50; 275 50 50"
            begin="0s"
            dur="1.5s"
            fill="freeze"
            repeatCount="indefinite"
          />
          <circle
            fill="none"
            stroke="black"
            stroke-width="10"
            stroke-linecap="square"
            cx="50"
            cy="50"
            r="44"
            stroke-dasharray="274"
            stroke-dashoffset="610"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 50 50; 135 50 50; 450 50 50"
              begin="0s"
              dur="1.5s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <animate
              attributeName="stroke-dashoffset"
              values="274; 68.57; 274"
              begin="0s"
              dur="1.5s"
              fill="freeze"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
    }
  </div>
}
